import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
export function FinalCTA() {
  const scrollToForm = () => {
    document.getElementById('formulario')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative py-32 px-6 bg-gradient-to-b from-[#0D2B6E] to-[#1B3A8C] overflow-hidden flex justify-center" data-id="element-83">
      {/* Subtle Gold Light Top Right */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-champagne-gold/10 blur-[100px] rounded-full pointer-events-none" data-id="element-84"></div>

      {/* Floating Particles */}
      {[...Array(10)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-champagne-gold rounded-full opacity-20" initial={{
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight
    }} animate={{
      y: [null, Math.random() * -50 - 20],
      opacity: [0.1, 0.3, 0.1]
    }} transition={{
      duration: Math.random() * 4 + 4,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-85" />)}

      <div className="relative z-10 max-w-[700px] w-full flex flex-col items-center text-center" data-id="element-86">
        <Logo className="w-[80px] h-[80px] mb-6" data-id="element-87" />
        <div className="w-[60px] h-[2px] bg-champagne-gold mb-8" data-id="element-88"></div>

        <span className="text-champagne-gold font-montserrat font-semibold text-sm tracking-[0.2em] uppercase mb-6" data-id="element-89">
          El Momento es Ahora
        </span>

        <h2 className="font-playfair font-bold text-white text-4xl md:text-[52px] leading-[1.3] mb-8" data-id="element-90">
          Tu Historia Está
          <br data-id="element-91" />
          Esperando Ser Contada
        </h2>

        <div className="font-montserrat text-white/80 text-lg leading-[1.9] mb-12 space-y-4" data-id="element-92">
          <p data-id="element-93">
            No la guardes más. No esperes tenerlo todo perfecto. No pienses que
            tu historia no es suficientemente buena.
          </p>
          <p data-id="element-94">
            Es perfecta exactamente como es. Porque es real. Y lo real
            transforma.
          </p>
          <p className="italic font-cormorant text-xl text-champagne-gold mt-6" data-id="element-95">
            — Lorena Pérez, 54 años,
            <br data-id="element-96" />
            25 años de este camino,
            <br data-id="element-97" />
            aquí con todo su corazón.
          </p>
        </div>

        <div className="w-[80px] h-[2px] bg-champagne-gold mb-12" data-id="element-98"></div>

        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} animate={{
        scale: [1, 1.02, 1]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} onClick={scrollToForm} className="bg-cta-gradient text-white font-montserrat font-bold text-lg py-[22px] px-[60px] rounded-full shadow-cta-shadow hover:shadow-cta-shadow-hover w-full md:w-auto mb-6" data-id="element-99">
          Comparto Mi Historia Ahora 💙
        </motion.button>

        <p className="font-montserrat font-light text-white/50 text-[13px]" data-id="element-100">
          Gratuito • Confidencial • Con propósito • Acompañado por Lorena 💙
        </p>
      </div>
    </section>;
}